import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PortalInvoicePaymentQuoteFragment = { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO };

export type PortalInvoiceCheckoutRefusalFragment = { __typename?: 'InvoiceCheckoutRefusal', code: Types.InvoiceCheckoutRefusalCode, retryable: boolean, message: string };

export type PortalInvoiceListRowFragment = { __typename?: 'CustomerPortalInvoice', invoiceId: string, invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, status: Types.CustomerInvoiceStatus, availability: { __typename?: 'InvoicePaymentAvailability', enabled: boolean, ready: boolean }, quote?: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } | null, openAttempt?: { __typename?: 'InvoicePaymentOpenAttempt', attemptId: string, status: Types.PaymentAttemptStatus } | null };

export type GetPortalInvoicesQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPortalInvoicesQuery = { __typename?: 'Query', customerPortalInvoices?: { __typename?: 'CustomerPortalInvoicesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerPortalInvoice', invoiceId: string, invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, status: Types.CustomerInvoiceStatus, availability: { __typename?: 'InvoicePaymentAvailability', enabled: boolean, ready: boolean }, quote?: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } | null, openAttempt?: { __typename?: 'InvoicePaymentOpenAttempt', attemptId: string, status: Types.PaymentAttemptStatus } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPortalInvoiceQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  invoiceId: Types.Scalars['String']['input'];
}>;


export type GetPortalInvoiceQuery = { __typename?: 'Query', customerPortalInvoice?: { __typename?: 'CustomerPortalInvoice', subtotal: number, freight: number, taxTotal: number, taxStatus: Types.InvoiceTaxStatus, depositApplied: number, amountPaid: number, invoiceId: string, invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, status: Types.CustomerInvoiceStatus, lines: Array<{ __typename?: 'CustomerPortalInvoiceLine', lineNumber: number, sku: string, itemName: string, shippedQuantity: number, unitPrice: number, discountAmount: number, extended: number, taxAmount: number }>, taxRows: Array<{ __typename?: 'CustomerPortalInvoiceTaxRow', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number }>, payments: Array<{ __typename?: 'CustomerPortalInvoicePayment', amount: number, method: Types.InvoicePaymentMethod, reference?: string | null, receivedDate: Types.TDateISO, discountTaken: number, lateChargeAssessed: number }>, availability: { __typename?: 'InvoicePaymentAvailability', enabled: boolean, ready: boolean }, quote?: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } | null, openAttempt?: { __typename?: 'InvoicePaymentOpenAttempt', attemptId: string, status: Types.PaymentAttemptStatus } | null } | null };

export type GetPortalInvoicePaymentQuoteQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  invoiceIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetPortalInvoicePaymentQuoteQuery = { __typename?: 'Query', customerPortalInvoicePaymentQuote: { __typename?: 'CustomerPortalInvoicePaymentQuotePayload', quote?: { __typename?: 'InvoicePaymentCombinedQuote', total: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO, invoices: Array<{ __typename?: 'InvoicePaymentQuoteLine', invoiceId: string, invoiceNumber: string, quote: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } }> } | null, refusal?: { __typename?: 'InvoiceCheckoutRefusal', code: Types.InvoiceCheckoutRefusalCode, retryable: boolean, message: string } | null } };

export type GetPortalInvoicePaymentAttemptQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  attemptId: Types.Scalars['String']['input'];
}>;


export type GetPortalInvoicePaymentAttemptQuery = { __typename?: 'Query', customerPortalInvoicePaymentAttempt?: { __typename?: 'InvoicePaymentAttempt', attemptId: string, status: Types.PaymentAttemptStatus, total: number, currency: string, lastFailure?: string | null, invoices: Array<{ __typename?: 'InvoicePaymentAttemptInvoice', invoiceId: string, allocatedAmount: number, appliedAmount: number, unappliedCreditAmount: number, discountApplied: number, state: Types.InvoicePaymentAllocationState }> } | null };

export const PortalInvoiceCheckoutRefusalFragmentDoc = new TypedDocumentString(`
    fragment PortalInvoiceCheckoutRefusal on InvoiceCheckoutRefusal {
  code
  retryable
  message
}
    `, {"fragmentName":"PortalInvoiceCheckoutRefusal"});
export const PortalInvoicePaymentQuoteFragmentDoc = new TypedDocumentString(`
    fragment PortalInvoicePaymentQuote on InvoicePaymentQuote {
  postedBalance
  discount
  lateCharge
  payableAmount
  currency
  quotedAt
  expiresAt
}
    `, {"fragmentName":"PortalInvoicePaymentQuote"});
export const PortalInvoiceListRowFragmentDoc = new TypedDocumentString(`
    fragment PortalInvoiceListRow on CustomerPortalInvoice {
  invoiceId
  invoiceNumber
  invoiceDate
  dueDate
  currency
  total
  postedBalance
  pendingAmount
  lastFailure
  status
  availability {
    enabled
    ready
  }
  quote {
    ...PortalInvoicePaymentQuote
  }
  openAttempt {
    attemptId
    status
  }
}
    fragment PortalInvoicePaymentQuote on InvoicePaymentQuote {
  postedBalance
  discount
  lateCharge
  payableAmount
  currency
  quotedAt
  expiresAt
}`, {"fragmentName":"PortalInvoiceListRow"});
export const GetPortalInvoicesDocument = new TypedDocumentString(`
    query GetPortalInvoices($tenantId: String!, $first: Int, $after: String, $last: Int, $before: String) {
  customerPortalInvoices(
    tenantId: $tenantId
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...PortalInvoiceListRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PortalInvoicePaymentQuote on InvoicePaymentQuote {
  postedBalance
  discount
  lateCharge
  payableAmount
  currency
  quotedAt
  expiresAt
}
fragment PortalInvoiceListRow on CustomerPortalInvoice {
  invoiceId
  invoiceNumber
  invoiceDate
  dueDate
  currency
  total
  postedBalance
  pendingAmount
  lastFailure
  status
  availability {
    enabled
    ready
  }
  quote {
    ...PortalInvoicePaymentQuote
  }
  openAttempt {
    attemptId
    status
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalInvoiceDocument = new TypedDocumentString(`
    query GetPortalInvoice($tenantId: String!, $invoiceId: String!) {
  customerPortalInvoice(tenantId: $tenantId, invoiceId: $invoiceId) {
    ...PortalInvoiceListRow
    subtotal
    freight
    taxTotal
    taxStatus
    depositApplied
    amountPaid
    lines {
      lineNumber
      sku
      itemName
      shippedQuantity
      unitPrice
      discountAmount
      extended
      taxAmount
    }
    taxRows {
      jurisdiction
      level
      state
      rate
      amount
      taxableAmount
    }
    payments {
      amount
      method
      reference
      receivedDate
      discountTaken
      lateChargeAssessed
    }
  }
}
    fragment PortalInvoicePaymentQuote on InvoicePaymentQuote {
  postedBalance
  discount
  lateCharge
  payableAmount
  currency
  quotedAt
  expiresAt
}
fragment PortalInvoiceListRow on CustomerPortalInvoice {
  invoiceId
  invoiceNumber
  invoiceDate
  dueDate
  currency
  total
  postedBalance
  pendingAmount
  lastFailure
  status
  availability {
    enabled
    ready
  }
  quote {
    ...PortalInvoicePaymentQuote
  }
  openAttempt {
    attemptId
    status
  }
}`);
export const GetPortalInvoicePaymentQuoteDocument = new TypedDocumentString(`
    query GetPortalInvoicePaymentQuote($tenantId: String!, $invoiceIds: [String!]!) {
  customerPortalInvoicePaymentQuote(tenantId: $tenantId, invoiceIds: $invoiceIds) {
    quote {
      total
      currency
      quotedAt
      expiresAt
      invoices {
        invoiceId
        invoiceNumber
        quote {
          ...PortalInvoicePaymentQuote
        }
      }
    }
    refusal {
      ...PortalInvoiceCheckoutRefusal
    }
  }
}
    fragment PortalInvoicePaymentQuote on InvoicePaymentQuote {
  postedBalance
  discount
  lateCharge
  payableAmount
  currency
  quotedAt
  expiresAt
}
fragment PortalInvoiceCheckoutRefusal on InvoiceCheckoutRefusal {
  code
  retryable
  message
}`);
export const GetPortalInvoicePaymentAttemptDocument = new TypedDocumentString(`
    query GetPortalInvoicePaymentAttempt($tenantId: String!, $attemptId: String!) {
  customerPortalInvoicePaymentAttempt(tenantId: $tenantId, attemptId: $attemptId) {
    attemptId
    status
    total
    currency
    lastFailure
    invoices {
      invoiceId
      allocatedAmount
      appliedAmount
      unappliedCreditAmount
      discountApplied
      state
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPortalInvoices: build.query<GetPortalInvoicesQuery, GetPortalInvoicesQueryVariables>({
      query: (variables) => ({ document: GetPortalInvoicesDocument, variables })
    }),
    GetPortalInvoice: build.query<GetPortalInvoiceQuery, GetPortalInvoiceQueryVariables>({
      query: (variables) => ({ document: GetPortalInvoiceDocument, variables })
    }),
    GetPortalInvoicePaymentQuote: build.query<GetPortalInvoicePaymentQuoteQuery, GetPortalInvoicePaymentQuoteQueryVariables>({
      query: (variables) => ({ document: GetPortalInvoicePaymentQuoteDocument, variables })
    }),
    GetPortalInvoicePaymentAttempt: build.query<GetPortalInvoicePaymentAttemptQuery, GetPortalInvoicePaymentAttemptQueryVariables>({
      query: (variables) => ({ document: GetPortalInvoicePaymentAttemptDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPortalInvoicesQuery, useLazyGetPortalInvoicesQuery, useGetPortalInvoiceQuery, useLazyGetPortalInvoiceQuery, useGetPortalInvoicePaymentQuoteQuery, useLazyGetPortalInvoicePaymentQuoteQuery, useGetPortalInvoicePaymentAttemptQuery, useLazyGetPortalInvoicePaymentAttemptQuery } = injectedRtkApi;
